import { CONTACT_CONFIG } from './constants'
import { buildSiteUrl, siteName, siteUrl } from './usePageSeo'

type BreadcrumbItem = {
   name: string
   path: string
}

type FaqItem = {
   question: string
   answer: string
}

export const organizationSchema = {
   '@context': 'https://schema.org',
   '@type': 'Organization',
   name: siteName,
   url: siteUrl,
   logo: buildSiteUrl('/favicon.ico'),
   telephone: CONTACT_CONFIG.hotline,
   sameAs: [CONTACT_CONFIG.fb_page, CONTACT_CONFIG.fb_group, CONTACT_CONFIG.tiktok],
   contactPoint: {
      '@type': 'ContactPoint',
      telephone: CONTACT_CONFIG.hotline,
      contactType: 'customer service',
      areaServed: 'VN',
      availableLanguage: ['vi-VN']
   }
}

export const websiteSchema = {
   '@context': 'https://schema.org',
   '@type': 'WebSite',
   name: siteName,
   url: siteUrl,
   inLanguage: 'vi-VN'
}

export const transportationServiceSchema = {
   '@context': 'https://schema.org',
   '@type': 'TransportationService',
   name: siteName,
   url: siteUrl,
   telephone: CONTACT_CONFIG.hotline,
   areaServed: ['Thanh Hóa', 'Hà Nội', 'Sầm Sơn', 'Bỉm Sơn', 'Nga Sơn', 'Hậu Lộc', 'Hoằng Hóa'],
   serviceType: ['Xe ghép Thanh Hóa Hà Nội', 'Xe ghép Hà Nội Thanh Hóa', 'Bao xe riêng', 'Gửi hàng trong ngày'],
   sameAs: [CONTACT_CONFIG.fb_page, CONTACT_CONFIG.fb_group],
   provider: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl
   }
}

export const breadcrumbSchema = (items: BreadcrumbItem[]) => ({
   '@context': 'https://schema.org',
   '@type': 'BreadcrumbList',
   itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: buildSiteUrl(item.path)
   }))
})

export const faqSchema = (items: FaqItem[]) => ({
   '@context': 'https://schema.org',
   '@type': 'FAQPage',
   mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
         '@type': 'Answer',
         text: item.answer
      }
   }))
})
